'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'question';
var width = 320;
var height = 512;
var aliases = [10067,10068,61736];
var unicode = '3f';
var svgPathData = ['M120 440a40 40 0 1 0 80 0 40 40 0 1 0 -80 0z', 'M144 96c-35.3 0-64 28.7-64 64l0 16-64 0 0-16C16 89.3 73.3 32 144 32l32 0c70.7 0 128 57.3 128 128l0 9.3c0 39.3-18 76.4-48.9 100.6L192 319.6l0 32.4-64 0 0-48 0-15.6 12.2-9.6 75.3-59.2C231 207.5 240 189 240 169.3l0-9.3c0-35.3-28.7-64-64-64l-32 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faQuestion = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;